// tslint:disable: max-line-length
export const devConfig = {
  apiHostUrl:
    "https://35hfko078c.execute-api.us-east-1.amazonaws.com/development",
  apiChatUrl: "https://chatdev.cuvo.io",
  feedbackMailAccount: "help@cuvo.io",
  enableJira: true,
  enableZendesk: true,
  enableMailReply: true,
  enableInsights: true,
  logLevel: "info",
  enableAnalytics: true,
  enableAiSettingsModelArchitecture: true,
  enableChatbot: true,
  enableFeedback: true,
  enableBugReport: true,
  enableFeatureRequest: true,
  enablePlaystore: true,
  enableCorrelation: true,
  enableDynamicFeedback: false,
  enableRecaptcha: false,
  uploadFileBucketName: "dev-cuvo-upload-photos",
  roleConfig: {
    "Admin": "role_54a4abb0-5baa-11ee-95c8-61f5b13b77a6", //need to change as "Admin" : "role_54a4abb0-5baa-11ee-95c8-61f5b13b77a6"
    "Manager": "role_1e5aa4a0-ee73-11ed-8433-9b65a494e10c",
    "Member": "role_5c223f90-f49b-11ed-9950-752210f6963e",
    "SuperAdmin": "role_da964420-ef4b-11ed-b335-9b40a9a62793",
  },
  reCaptchaSiteKey: "6LftCVMpAAAAAD1XJVAoBJkjZDVXP8U_dLO8L92A",
  commonEncrypt: {
    secret_key: "dev_cuvo_platform",
    iv: "081abc85b3938937b03438fb4df7d3cebc2e05fc", // sha1 hash generator value for devcuvoplatform
  },
};
